import { GatsbyImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import React from "react"

export function Client({ client }) {
  return (
    <a
      key={client.title}
      href={client.uri}
      className="flex flex-col items-start p-6 overflow-hidden bg-white border-2 border-transparent rounded-lg shadow-lg cursor-pointer hover:border-scooter-300 hover:ring-1 hover:ring-scooter-300"
    >
      {client?.clientAttributes?.logo?.localFile?.childImageSharp
        ?.gatsbyImageData && (
        <div className="flex-shrink-0 pb-2">
          <div className="">
            <GatsbyImage
              class="h-10"
              imgStyle={{ objectFit: "contain" }}
              image={
                client.clientAttributes.logo.localFile.childImageSharp
                  .gatsbyImageData
              }
              alt={client.clientAttributes.logo.altText}
            />
          </div>
        </div>
      )}
      <div className="flex flex-col grow flex-1bg-white">
        <p className="mt-2 text-xl font-semibold text-gray-900">
          {client.title}
        </p>
        <p className="mt-3 text-base text-gray-500">{parse(client.excerpt)}</p>
        <div className="flex items-end grow mt-6">
          <div className="flex-shrink-0">
            <span className="sr-only">
              {client.clientAttributes.testimonial.firstname}{" "}
              {client.clientAttributes.testimonial.lastname}
            </span>
            {client?.clientAttributes?.testimonial?.picture?.localFile
              ?.childImageSharp?.gatsbyImageData && (
              <GatsbyImage
                className="w-10 h-10 rounded-full"
                image={
                  client.clientAttributes.testimonial.picture.localFile
                    .childImageSharp.gatsbyImageData
                }
                alt={client.clientAttributes.testimonial.picture.altText}
              />
            )}
          </div>
          {(client.clientAttributes.testimonial.firstname ||
            client.clientAttributes.testimonial.lastname ||
            client.clientAttributes.testimonial.job) && (
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">
                {client.clientAttributes.testimonial.firstname}{" "}
                {client.clientAttributes.testimonial.lastname}
              </p>
              <div className="flex space-x-1 text-sm text-gray-500">
                {client.clientAttributes.testimonial.job}, {client.title}
              </div>
            </div>
          )}
        </div>
      </div>
    </a>
  )
}
